import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  vendors: [],
  pendingProducts: [],
  paymentSummary: [],
  total: 0,
  pages: 0,
  error: null,
  success: false,
  message: null,
};

export const vendorReducer = createReducer(initialState, {
  getVendorApplicationsRequest: (state) => { state.isLoading = true; },
  getVendorApplicationsSuccess: (state, action) => {
    state.isLoading = false;
    state.vendors = action.payload.vendors;
    state.total = action.payload.total;
    state.pages = action.payload.pages;
  },
  getVendorApplicationsFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  approveVendorRequest: (state) => { state.isLoading = true; },
  approveVendorSuccess: (state, action) => {
    state.isLoading = false;
    state.success = true;
    state.message = action.payload.message;
  },
  approveVendorFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  rejectVendorRequest: (state) => { state.isLoading = true; },
  rejectVendorSuccess: (state, action) => {
    state.isLoading = false;
    state.success = true;
    state.message = action.payload.message;
  },
  rejectVendorFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  adminApproveProductRequest: (state) => { state.isLoading = true; },
  adminApproveProductSuccess: (state, action) => {
    state.isLoading = false;
    state.success = true;
    state.message = action.payload.message;
  },
  adminApproveProductFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  adminRejectProductRequest: (state) => { state.isLoading = true; },
  adminRejectProductSuccess: (state, action) => {
    state.isLoading = false;
    state.success = true;
    state.message = action.payload.message;
  },
  adminRejectProductFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  adminSetPriceRequest: (state) => { state.isLoading = true; },
  adminSetPriceSuccess: (state, action) => {
    state.isLoading = false;
    state.success = true;
    state.message = action.payload.message;
  },
  adminSetPriceFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  getPendingProductsRequest: (state) => { state.isLoading = true; },
  getPendingProductsSuccess: (state, action) => {
    state.isLoading = false;
    state.pendingProducts = action.payload.products;
    state.total = action.payload.total;
    state.pages = action.payload.pages;
  },
  getPendingProductsFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  getVendorPaymentSummaryRequest: (state) => { state.isLoading = true; },
  getVendorPaymentSummarySuccess: (state, action) => {
    state.isLoading = false;
    state.paymentSummary = action.payload;
  },
  getVendorPaymentSummaryFailed: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  clearVendorErrors: (state) => { state.error = null; },
  clearVendorSuccess: (state) => { state.success = false; state.message = null; },
});
